<template>
  <span class="create-list-option">
    <v-footer absolute class="position-sticky" padless>
      <v-list-item class="create-new-contact-list" @click.stop="openList">
        <div
          id="create-new-list-wrapper"
          class="d-flex justify-center align-center"
        >
          <v-list-item-icon class="mr-5">
            <v-icon v-text="'mdi-plus'" color="white" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              class="white--text"
              v-text="itemText"
              color="white"
            />
          </v-list-item-content>
        </div>
      </v-list-item>
    </v-footer>
    <!-- Create new contact list drawer -->
  </span>
</template>

<script>
/**
 * Create new list option
 * @author {Jatin Kamboj}
 * @description Use this create list option through out integrations contact list dropdown
 */
export default {
  name: "CreateListOption",
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  props: {
    itemText: { type: String, default: "Create List" }
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {
    /**
     * @emits open-list event in parent component
     */
    openList() {
      this.$emit("open-list");
    }
  }
};
</script>

<style lang="scss" scoped>
.create-new-contact-list {
  height: 36px;
  background-color: #1e2533;
  color: #ffffff !important;
}
</style>
